module.exports = __webpack_public_path__ + "img/real-time02.25a5733e.jpg";